import { WatchQueryFetchPolicy } from '@apollo/client';
import { LAST_5_YEARS } from '@modules/common/constants';
import { getWhereClauseForCohortsField } from '@modules/common/utils';
import { GetAggregatesResponse } from 'generated/graphql';
import { TimeRange } from 'v2/core/entities';
import useExecuteEQL from 'v2/core/repository/edge-server/eql/useExecuteEQL';
import { IsLoading, QueryStatus } from 'v2/core/repository/edge-server/types';
import { EQLProps, ExpressionType } from 'v2/core/repository/eql/types';
import { useGetUser } from 'v2/core/services/user';

interface UseFetchRecordCountForCohortGroupOptions {
  cohortName: string;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
}

export function useFetchRecordCountForCohortGroup({
  cohortName,
  skip,
  fetchPolicy = 'cache-and-network',
}: UseFetchRecordCountForCohortGroupOptions) {
  const {
    tenant: { id: tenantID, timezone },
  } = useGetUser();

  const eqlProps: Omit<EQLProps, 'sourceDetailsMap'> = {
    expressionType: ExpressionType.Aggregates,
    timezone,
    dateRange: LAST_5_YEARS as TimeRange,
    whereClause: getWhereClauseForCohortsField(cohortName),
  };

  const { data, error, status, refetch } = useExecuteEQL({
    input: {
      tenantID,
      eqlProps,
    },
    options: {
      FetchPolicy: fetchPolicy,
      Skip: skip,
    },
  });

  const getAggregates = data as GetAggregatesResponse;

  return {
    error,
    status,
    recordCount:
      status === QueryStatus.SUCCESS_COMPLETED
        ? getAggregates.data[0]?.value ?? 0
        : undefined,
    refetch,
    isLoading: IsLoading(status),
  };
}
